import React, { useEffect, useState } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import E_Amount from "./view/_amount";
import E_LASTRECHARGE from "./view/_last_recharge";
import E_Button from "./view/_button";
import { useSelector } from "react-redux";
import { getContentData } from "../model/service";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { useMediaQuery } from "react-responsive";

const useStyle = makeStyles((theme) => ({
  whiteColorFont: {
    color: theme.palette.eWhite?.base,
    paddingTop: "5%",
  },
  greenLine: {
    backgroundColor: theme.palette.eSecondary?.base,
    padding: "1% 5%",
    color: theme.palette.eWhite?.base,
  },
  accountPart: {
    height: "49.5vh",
    [theme.breakpoints.down("md")]: {
      height: "76%",
    },
  },
  margin:{
    marginTop:'10%',
    [theme.breakpoints.down("md")]:{
      marginTop: '5rem',
      marginBottom: '2rem'
     }
  },
  lastRechargemargin: {
    marginTop: "4rem",
    [theme.breakpoints.down("md")]: {
      marginTop: "3rem",
      marginBottom: "2rem",
    },
  },
  marginMobile: {
    marginTop: "4rem",
    marginBottom: "2rem",
  },
  desktopStyle: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}));

export default function E_PrepaidpaidAccountSummary() {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [latestDate,setlatestDate]=useState()
  const [latestAmt,setLatestAmt]=useState()
  let classes = useStyle();
  const { t: labels, ready: labelReady } = useTranslation(
    "label-E_PREPAID_ACCOUNTSUMMARY"
  );
  const { t: contents, ready: contentReady } = useTranslation(
    "content-E_PREPAID_ACCOUNTSUMMARY"
  );
  let isPrepaid = useSelector(
    (store) => store?.meterDetails?.getSaInfo?.isPrepaidSa
  );
  return (
    <Grid container={isMobile} className={classes.accountPart}>
      <Grid item xs={12} className={classes.desktopStyle}>
        <div>
          {labelReady ? (
            <Typography
              className={classes.whiteColorFont}
              variant="h6"
              align="center"
            >
              <b>{labels("E_PREPAID_BALANCE")}</b>
            </Typography>
          ) : (
            <Skeleton />
          )}
        </div>
        <div
          className={isMobile ? classes.marginMobile : classes.margin}
        >
          <E_Amount setLatestAmt={setLatestAmt} setlatestDate={setlatestDate} content={contents} contentReady={contentReady} />
          <E_Button content={contents} contentReady={contentReady} />
        </div>
        <div>{isPrepaid === "Y" && <E_LASTRECHARGE latestDate={latestDate} latestAmt={latestAmt} />}</div>
      </Grid>
      {/* <Grid item xs={12}>
      
      </Grid> */}
      {/* <Grid item xs={12}>
        
      </Grid>
      <Grid item xs={12} >
      </Grid> */}
    </Grid>
  );
}
